import { gql } from '@apollo/client';

const AI_EVENT_STRIPS_QUERY = gql`
  query holterEvents($filter: HolterEventsFilter!, $limit: Int) {
    holterEvents(filter: $filter, limit: $limit) {
      isSuccess
      message
      events {
        id
        start
        stop
        type
        technicianComments
        comment
        minHr
        maxHr
        isIncludedToReport
        channel
        title
        strips {
          id
          isSelected
          images
          draw
          start
          stop
          comment
          draw
          userUpdated
        }
      }
    }
  }
`;

export default AI_EVENT_STRIPS_QUERY;
